let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gGUk5")).then(() => parcelRequire('4K8kV'));